import { Scissors, MapPin, Phone, Calendar } from "lucide-react";

// Klassique Barbers — Brixton · Bold, sharp, masculine
export default function KlassiqueAfter({ b }) {
  return (
    <div className="bg-black text-white">
      <div className="px-6 md:px-10 py-4 flex items-center justify-between border-b border-white/10">
        <div className="font-anton text-2xl tracking-wider">KLASSIQUE<span className="text-[#E63946]">.</span></div>
        <nav className="hidden md:flex gap-6 text-xs uppercase tracking-[0.3em] text-white/60">
          <span>Cuts</span><span>Chairs</span><span>Shop</span><span>Book</span>
        </nav>
        <button className="bg-[#E63946] text-white px-4 py-2 text-xs uppercase tracking-[0.2em] font-bold">Book chair</button>
      </div>

      {/* Hero */}
      <div className="relative overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{ backgroundImage: "url(https://images.pexels.com/photos/1319459/pexels-photo-1319459.jpeg)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/60 to-transparent" />
        <div className="relative px-6 md:px-10 py-20 md:py-32">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#E63946] mb-6">81 ATLANTIC RD · BRIXTON · SW9</p>
          <h1 className="font-anton text-7xl md:text-9xl lg:text-[11rem] leading-[0.85] tracking-tight uppercase">
            Sharp lines.<br/>
            <span className="text-[#E63946]">No bull.</span>
          </h1>
          <p className="mt-8 max-w-md text-lg text-white/80">
            Brixton's most-booked chair, walked-in by everyone from Atlantic Road dads to Saturday-night ravers since 2009.
          </p>
          <div className="mt-10 flex gap-3">
            <button className="bg-[#E63946] text-white px-8 py-4 font-anton text-2xl uppercase tracking-wider hover:bg-white hover:text-black transition-colors">Book a chair</button>
            <button className="border border-white text-white px-8 py-4 font-anton text-2xl uppercase tracking-wider">See cuts</button>
          </div>
        </div>
      </div>

      {/* Services strip */}
      <div className="border-y border-white/10 bg-[#0a0a0a]">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-white/10">
          {[
            ["Skin fade", "£22", "45 min"],
            ["Beard sculpt", "£15", "20 min"],
            ["Hot towel shave", "£28", "40 min"],
            ["The full Klassique", "£42", "75 min"],
          ].map(([t, p, d]) => (
            <div key={t} className="p-6 hover:bg-[#E63946]/10 transition-colors">
              <Scissors className="w-5 h-5 text-[#E63946] mb-3" />
              <div className="font-anton text-2xl uppercase tracking-wide">{t}</div>
              <div className="flex justify-between mt-3 text-xs text-white/60 font-mono">
                <span>{p}</span><span>{d}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Chairs */}
      <div className="px-6 md:px-10 py-20">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#E63946] mb-4">PICK YOUR CHAIR</p>
        <h2 className="font-anton text-5xl md:text-7xl uppercase tracking-wide mb-10">Four chairs. Four characters.</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          {["Marcus", "Dele", "Sami", "Ren"].map((n, i) => (
            <div key={n} className="border border-white/15 hover:border-[#E63946] p-6 transition-colors">
              <div className="font-mono text-xs text-white/40">CHAIR 0{i + 1}</div>
              <div className="font-anton text-3xl uppercase mt-2">{n}</div>
              <div className="mt-4 text-xs text-white/60">{["Skin fades · Afros", "Tapers · Beards", "Curly · Textured", "Classic · Pompadours"][i]}</div>
              <div className="mt-4 inline-flex items-center gap-2 text-[#E63946] text-xs uppercase tracking-wider"><Calendar className="w-3 h-3" /> Next slot today</div>
            </div>
          ))}
        </div>
      </div>

      {/* Visit */}
      <div className="px-6 md:px-10 py-16 bg-[#0a0a0a] border-t border-white/10 grid grid-cols-1 md:grid-cols-2 gap-10">
        <div>
          <h3 className="font-anton text-5xl uppercase">Walk in.<br/>Sit down.<br/><span className="text-[#E63946]">Get on.</span></h3>
        </div>
        <div className="space-y-3 text-sm">
          <p className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#E63946]" /> {b.address}</p>
          <p className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#E63946]" /> {b.phone}</p>
          <p className="font-mono text-xs text-white/50 mt-4">⭐ {b.rating} · {b.reviews} Google reviews</p>
        </div>
      </div>
    </div>
  );
}
